import { addMessages, init, locale } from "svelte-i18n";
import { LangEnums, storageModel } from "../libs/storage-manager";

// 翻译文件由 scripts/pull-i18n.mjs 从 Tolgee 拉取后直接写入 assets/langs
import zhCn from "./assets/langs/zh-cn.json";
import zhHk from "./assets/langs/zh-hk.json";

addMessages("zh-cn", zhCn);
addMessages("zh-hk", zhHk);

let lang = "zh-hk"; // 默认繁体（端外 / 英文 / 韩文）
if (storageModel.language === LangEnums.zhCN) {
  lang = "zh-cn";
}

init({
  fallbackLocale: "zh-hk",
  initialLocale: lang,
});
locale.set(lang);
